<template>
	<div class="user-console">
		<SidebarMacro class="no-tablet" />
		<main>
			<router-view />
		</main>
	</div>
</template>

<script>
import SidebarMacro from "@/console-new/components/shared/SidebarMacro.vue";
import langObject from "@/user/assets/json/langs.json";
import langObjectAuto from "@/user/assets/json/auto.json";

import {useUserStore} from "@/user/stores";
import {useLanguageStore, useCurrencyStore} from "@/shared/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const currencyStore = useCurrencyStore();
		return { languageStore, userStore, currencyStore };
	},
	name: "App",
	components: {SidebarMacro},
	created() {
		this.languageStore.addStrings(langObject, "user", langObjectAuto);
		if(import.meta.env.VITE_MODE === 'development') {
			this.languageStore.setLang(this.languageStore.availableLanguages[Math.floor(Math.random()*this.languageStore.availableLanguages.length)]);
		}
		this.userStore.init(URL_HTML + '/user');

		this.userStore.initDarkMode();

		this.currencyStore.initCurrency(this.userStore?.currBusiness?.country)
	},
	watch: {
		'userStore.currBusiness': {
			handler() {
				this.currencyStore.initCurrency(this.userStore?.currBusiness?.country)
			},
			deep: true
		}
	}
}
</script>

<style lang="scss">
.vc-nav-items {
	.vc-nav-item {
		color: var(--txt-0);
	}
}
</style>
<style lang="scss" scoped>
.user-console {
	display: flex;
	align-items: stretch;
	height: 100%;
}

main {
	width: calc(100% - $sidebarMacroWidth);
	height: 100%;
	position: relative;
	background-color: var(--color-bg-primary-1);
}

@media (max-width: 920px) {
	.no-tablet {
		display: none;
	}
	main {
		width: 100%;
	}
}
</style>